import Model from '../orm/Model'
import Input from '../orm/Input'
import SchoolClosure from './SchoolClosure'

const schoolInput = new Input('SchoolInput!', [ 
    'name',
    'address',
    'contact_person',
    'phone',
    'email',
    'late_time',
    'absent_time',
    'leave_time',
    'warning_percentage',
    'timezone',
    'token_pattern',
    'student_cap',
    'support_email'
])

export default class School extends Model {

    static entity = 'schools'

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            address: this.attr(''),
            contact_person: this.attr(''),
            phone: this.attr(''),
            email: this.attr(''),
            support_email: this.attr(''),
            late_time: this.attr(null),
            absent_time: this.attr(null),
            leave_time: this.attr(null),
            warning_percentage: this.attr(null),
            timezone: this.attr(''),
            token_pattern: this.attr('random'),
            student_cap: this.attr(''),
            closures: this.hasMany(SchoolClosure, 'school_id'),
            api_keys: this.array([], ['token', 'expiration'])
        }
    }

    static graphql = {
        all: {
            paginated: true,
            parameters: {
                page: 'Int',
                per_page: 'Int',
                sort_by: 'String',
                sort_dir: 'String',
                state: 'String',
                relation: 'String',
                relation_uuid: 'String'
            }
        },
        one: {
            type: 'school',
            include: {
                closures: true,
                api_keys: true
            }
        },
        create: {
            type: 'createSchool',
            parameters: {
                input: schoolInput 
            }
        },
        update: {
            type: 'updateSchool',
            parameters: {
                id: 'Int!',
                input: schoolInput
            }
        }
    }

    static timezones = [
        { value: 'America/New_York', label: 'Eastern (New York)' },
        { value: 'America/Chicago', label: 'Central (Chicago)' },
        { value: 'America/Denver', label: 'Mountain (Denver)' },
        { value: 'America/Phoenix', label: 'Moutain (Phoenix)' },
        { value: 'America/Los_Angeles', label: 'Pacific (Los Angeles)' },
        { value: 'America/Anchorage', label: 'Alaska (Anchorage)' },
        { value: 'America/Adak', label: 'Hawaii (Adak)' },
        { value: 'Pacific/Honolulu', label: 'Hawaii (Honolulu)' }
    ]
}